package com.taocent.simple.compose.component.blockrichtext

/**
 * 触发表格容器自动滚动的请求载荷。
 *
 * 由 [BlockState.pendingTableScrollRequest] 持有,产生于以下导航入口:
 *   - 表格级左/右高亮([BlockState.navSelectTable] / [BlockState.navSelectTableAfter])
 *   - 行级左/右高亮([BlockState.navSelectRowBefore] / [BlockState.navSelectRowAfter])
 *
 * 当列数超过 `maxColumnsBeforeScroll` 时,表格容器在水平方向上变成可滚动,用户可能
 * 自己滑动了让锚点高亮线(行左/行右)被滚出可视区域。该请求让 TableRenderer 在
 * 下一帧把容器滚到首列([scrollToStart]=true)或末列([scrollToStart]=false),
 * 保证锚点高亮一定可见。
 *
 * 一次性消费,处理后由 TableRenderer 立刻清空。
 */
internal data class PendingTableScrollRequest(
    val tableId: String,
    val scrollToStart: Boolean
)
